import groq from 'groq'
import { imageObject } from '../atoms/imageObject'
export const LogoGallery2Query = groq`
    _type == 'LogoGallery2' => {
    ...,
    images[]{

          ...,
           asset->{
            ...,
            _id,
            url,
            _type,
            altText,
            description,
            title,
              metadata {
                blurHash,
                dimensions,
              }
            }
    },
  }`
